export default "__VITE_ASSET__CoTl3rb3__"